import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import OrdersEntity, {
	OrderStatus,
	ShippingInfo,
} from '@/entities/api/orders/orders'

export const createOrder = async (
	token: string,
	data: Partial<OrdersEntity>
) => {
	const response = await axios.post(`${API_URL}/orders`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const fetchOrders = async (
	token: string,
	params?: { limit?: number; offset?: number; status?: string }
) => {
	const response = await axios.get(`${API_URL}/orders`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		params,
		validateStatus: (status) => status < 500,
	})
	return response
}

export const fetchOrderById = async (token: string, id: string) => {
	const response = await axios.get(`${API_URL}/orders/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const updateOrderStatusById = async (
	token: string,
	id: string,
	status: { status: OrderStatus }
) => {
	const response = await axios.patch(`${API_URL}/orders/status/${id}`, status, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const updateOrderShippingInfoById = async (
	token: string,
	id: string,
	shippingInfo: Partial<ShippingInfo>,
	files: File[]
) => {
	const formData = new FormData()
	formData.append('ShippingInfo', JSON.stringify(shippingInfo))
	files.forEach((file) => formData.append('files', file))

	const response = await axios.patch(
		`${API_URL}/orders/shipping/image/${id}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'multipart/form-data',
			},
			validateStatus: (status) => status < 500,
		}
	)
	return response
}

export const updateOrderShippingInfoWithoutImageById = async (
	token: string,
	id: string,
	shippingInfo: Partial<ShippingInfo>
) => {
	const response = await axios.patch(
		`${API_URL}/orders/shipping/${id}`,
		shippingInfo,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	return response
}

export const updateOrderDenialById = async (
	token: string,
	id: string,
	denial: { denial: string; customerName: string; customerEmail: string }
) => {
	const response = await axios.patch(`${API_URL}/orders/denial/${id}`, denial, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const updateOrderRefundedById = async (
	token: string,
	id: string,
	data: { reason: string }
) => {
	const response = await axios.patch(`${API_URL}/orders/refunded/${id}`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const removeOrderById = async (token: string, id: string) => {
	const response = await axios.delete(`${API_URL}/orders/${id}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}
